module.exports = __webpack_public_path__ + "img/refer5.png";